import React from 'react'

export default function Section6() {
    return (
        <div className='w-[90%] mx-auto pb-10 lg:pb-20'>
            <div data-aos='fade-up' data-aos-duration='1500'>
            <h1 className="text-[#269DDF] text-center font-bold text-2xl lg:text-3xl uppercase">The Journey Ahead</h1>
            <p className='text-center lg:w-[60%] mx-auto mt-3'>At Finkey Exchange, we're building the future of compliant and secure virtual asset trading. Here’s what’s next on our roadmap as we continue to lead and innovate in the space:</p>
            </div>
            <div data-aos='fade-up' data-aos-duration='2000' className='mt-5 p-7 lg:p-10 bg-white/10 rounded-xl relative '>
                <div className='relative flex flex-col lg:flex-row gap-10 lg:gap-0 justify-around text-center' style={{ zIndex: 1 }}>
                    <div className='w-[100%] lg:w-[25%]'>
                        <div className='flex justify-center mb-5'>
                            <div className='back-blur w-14 h-14 rounded-full bg-white/5 grid place-content-center'>
                                <img src='/assets/icons/headphone.svg'></img>
                            </div>
                        </div>
                        <h1 className='font-medium text-xl josefin-sans-regular'>Live VARA-Compliant OTC Platform</h1>
                        <p className='text-white/75'>Launching a fully regulated platform to enable fast, secure, and seamless transactions. </p>
                    </div>

                    <div className='w-[100%] lg:w-[25%]'>
                        <div className='flex justify-center mb-5'>
                            <div className='back-blur w-14 h-14 rounded-full bg-white/5 grid place-content-center'>
                                <img src='/assets/icons/Users.svg'></img>
                            </div>
                        </div>
                        <h1 className='font-medium text-xl josefin-sans-regular'>Institutional-Grade Services</h1>
                        <p className='text-white/75'>Rolling out high-liquidity, customizable solutions tailored for enterprises and high-volume traders. </p>
                    </div>
                    <div className='w-[100%] lg:w-[25%]'>
                        <div className='flex justify-center mb-5'>
                            <div className='back-blur w-14 h-14 rounded-full bg-white/5 grid place-content-center'>
                                <img src='/assets/icons/Book.svg'></img>
                            </div>
                        </div>
                        <h1 className='font-medium text-xl josefin-sans-regular'>Asset Expansion & Innovation</h1>
                        <p className='text-white/75'>Introducing a wider range of digital assets and tokenized products. </p>
                    </div>
                </div>
                <img src='/assets/others/Graph.svg' className='hidden lg:block w-full absolute top-1/2 2xl:top-[65%] -translate-y-1/2 left-0'></img>
            </div>
        </div>
    )
}
